<template>
    <FormEvent :url="$route.params.url" />
</template>

<script>
// @ is an alias to /src

import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, onMounted, onUnmounted } from "vue";
import FormEvent from "@/components/dashboard/forms/Event.vue";
import { axiosToken } from "@/libs/http";

export default {
    name: "GameView",
    components: { FormEvent },
    setup(props) {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        onMounted(() => {});

        return {};
    },
};
</script>
